var map = {
	"./ActionsModal/Cambio.vue": 799,
	"./ActionsModal/SaveChanges.vue": 800,
	"./ActionsModal/index.vue": 245,
	"./agrocolor.vue": 2046,
	"./araporcei.vue": 2047,
	"./coplaca/ParcelasActionsMultiple.vue": 1117,
	"./coplaca/index.vue": 2048,
	"./default.vue": 2049,
	"./demo.vue": 2050,
	"./sites.vue": 292,
	"./widgets/auditorias.vue": 801,
	"./widgets/dictamenes.vue": 804,
	"./widgets/pacs.vue": 806,
	"./widgets/revisiones.vue": 803,
	"./widgets/solicitudes.vue": 802,
	"./widgets/toma_muestras.vue": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;